"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function clientIsShopeeApp() {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /Shopee/.test(userAgent) && /Beeshop/.test(userAgent);
}
exports.default = clientIsShopeeApp;
//# sourceMappingURL=clientIsShopeeApp.js.map